import styled from '@emotion/styled';
import { AdAnalyticsFilter, AdAnalyticsPlacementTypes } from '@kaizenplatform/hugot-entity';
import { FormControl, InputLabel, MenuItem, Select, Typography } from '@material-ui/core';
import { Chip as _Chip } from '@material-ui/core';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { SPACING_REGULAR } from '../../constant/spacing';
import { flexibleLayoutContainer } from '../../styleUtility/flexibleLayout';

type Props = {
  placementTypes: AdAnalyticsPlacementTypes | null;
  selectedPlacementTypes: AdAnalyticsFilter;
  className?: string;
};

const Filters: FC<Props> = ({
  placementTypes,
  selectedPlacementTypes,
  className,
}: {
  placementTypes: AdAnalyticsPlacementTypes | null;
  selectedPlacementTypes: AdAnalyticsFilter;
  className?: string;
}) => {
  if (!placementTypes) {
    return null;
  }
  const periods = placementTypes.periods;

  // platform一覧を取得
  let platformKeys: string[] = [];
  placementTypes.platforms.map((platform) => platformKeys.push(platform.key));
  platformKeys = Array.from(new Set(platformKeys));

  // 選択されたplatformで絞り込んだmedia一覧を表示
  const selectedPlatform = selectedPlacementTypes.platformKey;
  let mediaKeys: string[] = [];
  const availablePlatforms = placementTypes.platforms.filter(
    (platform) => selectedPlatform !== undefined && selectedPlatform.indexOf(platform.key) !== -1,
  );
  availablePlatforms.map(
    (platform) => platform.networks !== undefined && platform.networks.map((media) => mediaKeys.push(media.key)),
  );
  mediaKeys = Array.from(new Set(mediaKeys));

  // 選択されたmediaで絞り込んだplacement一覧を表示.
  const selectedMedia = selectedPlacementTypes.mediaKey;
  let placementKeys: string[] = [];
  availablePlatforms.map(
    (platform) =>
      platform.networks !== undefined &&
      platform.networks
        .filter((media) => selectedMedia !== undefined && selectedMedia.indexOf(media.key) !== -1)
        .map(
          (media) =>
            media.placements !== undefined && media.placements.map((placement) => placementKeys.push(placement.key)),
        ),
  );
  placementKeys = Array.from(new Set(placementKeys));

  return (
    <Root className={className}>
      <Selector>
        <InputLabel>
          <FormattedMessage id="adAnalytics_detail.label_platform" />
        </InputLabel>
        <Select
          multiple={true}
          name="platform"
          value={selectedPlacementTypes.platformKey !== undefined ? selectedPlacementTypes.platformKey : []}
          renderValue={(selected) => (
            <Chips>
              {(selected as string[]).map((value) => (
                <Chip key={value} label={value} />
              ))}
            </Chips>
          )}
          disabled={true}
          displayEmpty
        >
          {platformKeys.map((platformKey, index) => (
            <SizedMenuItem value={platformKey} key={`PlatformSelector-${platformKey}${index}`}>
              <Typography>{platformKey}</Typography>
            </SizedMenuItem>
          ))}
        </Select>
      </Selector>

      <Selector>
        <InputLabel>
          <FormattedMessage id="adAnalytics_detail.label_media" />
        </InputLabel>
        <Select
          multiple={true}
          name="media"
          value={selectedPlacementTypes.mediaKey !== undefined ? selectedPlacementTypes.mediaKey : []}
          renderValue={(selected) => (
            <Chips>
              {(selected as string[]).map((value) => (
                <Chip key={value} label={value} />
              ))}
            </Chips>
          )}
          displayEmpty
          disabled={true}
        >
          {mediaKeys.map((mediaKey, index) => (
            <SizedMenuItem value={mediaKey} key={`MediaSelector-${mediaKey}${index}`}>
              <Typography>{mediaKey}</Typography>
            </SizedMenuItem>
          ))}
        </Select>
      </Selector>

      <Selector>
        <InputLabel>
          <FormattedMessage id="adAnalytics_detail.label_placement" />
        </InputLabel>
        <Select
          multiple={true}
          name="placement"
          value={selectedPlacementTypes.placementKey !== undefined ? selectedPlacementTypes.placementKey : []}
          renderValue={(selected) => (
            <Chips>
              {(selected as string[]).map((value) => (
                <Chip key={value} label={value} />
              ))}
            </Chips>
          )}
          displayEmpty
          disabled={true}
        >
          {placementKeys.map((placementKey, index) => (
            <SizedMenuItem value={placementKey} key={`PlacementSelector-${placementKey}${index}`}>
              <Typography>{placementKey}</Typography>
            </SizedMenuItem>
          ))}
        </Select>
      </Selector>

      <Selector>
        <InputLabel>
          <FormattedMessage id="adAnalytics_detail.label_period" />
        </InputLabel>
        <Select name="period" value={selectedPlacementTypes.period} displayEmpty disabled={true}>
          {periods.map((period, index) => (
            <SizedMenuItem value={period} key={`PeriodSelector-${period}${index}`}>
              <Typography>
                <FormattedMessage id={`adAnalytics_detail.select_value.${period}`} />
              </Typography>
            </SizedMenuItem>
          ))}
        </Select>
      </Selector>
    </Root>
  );
};

const Root = styled('div')(
  flexibleLayoutContainer({
    alignItems: 'center',
    justifyContent: 'flex-end',
  }),
);

const Selector = styled(FormControl)({
  minWidth: 185,
  marginLeft: SPACING_REGULAR,
});

const SizedMenuItem = styled(MenuItem)({
  maxWidth: 360,
});

const Chip = styled(_Chip)({
  margin: '2px',
});

const Chips = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
});

export default Filters;
